module.exports = __webpack_public_path__ + "img/guide08.4e6397cb.png";